/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Modifications_P1Inputs */

const es_tyc_modifications_p1 = /** @type {(inputs: Tyc_Modifications_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata se reserva el derecho de modificar o reemplazar estos Terminos en cualquier momento. Los cambios seran efectivos tras su publicacion. El uso continuado del Servicio despues de dichas modificaciones constituye la aceptacion de los Terminos revisados.`)
};

const en_tyc_modifications_p1 = /** @type {(inputs: Tyc_Modifications_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata reserves the right to modify or replace these Terms at any time. Changes will be effective upon publication. Continued use of the Service after such modifications constitutes acceptance of the revised Terms.`)
};

/**
* | output |
* | --- |
* | "Nexata reserves the right to modify or replace these Terms at any time. Changes will be effective upon publication. Continued use of the Service after such m..." |
*
* @param {Tyc_Modifications_P1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_modifications_p1 = /** @type {((inputs?: Tyc_Modifications_P1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Modifications_P1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_modifications_p1(inputs)
	return en_tyc_modifications_p1(inputs)
});
export { tyc_modifications_p1 as "tyc.modifications.p1" }